namespace PaperTrail.NewsletterControl {
    export interface NewsRow {
        NewsId?: number;
        Content?: string;
        Url?: string;
        ImageBytes?: number[];
        Title?: string;
        Subtitle?: string;
    }

    export namespace NewsRow {
        export const idProperty = 'NewsId';
        export const nameProperty = 'Content';
        export const localTextPrefix = 'NewsletterControl.News';
        export const lookupKey = 'NewsletterControl.News';

        export function getLookup(): Q.Lookup<NewsRow> {
            return Q.getLookup<NewsRow>('NewsletterControl.News');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            NewsId = "NewsId",
            Content = "Content",
            Url = "Url",
            ImageBytes = "ImageBytes",
            Title = "Title",
            Subtitle = "Subtitle"
        }
    }
}
